import React, { Component } from 'react';
import { withRouter } from 'react-router';
import ReactGA from 'react-ga';

import firebase from "../firebase/FirebaseProvider";
import './google.css';

class GoogleAuthButton extends Component {
    constructor(props) {
        super(props);
        this.auth = firebase.auth();
        this.provider = new firebase.auth.GoogleAuthProvider();
        this.handleOnClick = this.handleOnClick.bind(this);
    }

    handleOnClick() {
        ReactGA.event({
            category: 'Login',
            action: 'Google Login',
            label: 'Login Initiated'
        });
        const self = this;
        this.auth.signInWithPopup(this.provider)
            .then(function (authData) {
                // alert("Login successful for user: "+JSON.stringify(authData));
                if(self.props.match.path == '/login') {
                    self.props.history.push("/");
                }
            })
            .catch(function (error) {
                console.log(error);
                const errorMsg = JSON.stringify(error);
                ReactGA.event({
                    category: 'Login',
                    action: 'Google Login Error',
                    label: errorMsg
                });
            });
    }

    render() {
        return (
            <button className="googleSigninButton" onClick={this.handleOnClick}>
                LOGIN WITH GOOGLE
            </button>
        );
    }
}

export default withRouter(GoogleAuthButton);